<template>
  <b-modal
    body-class="padding"
    button-size="sm"
    size="md"
    title="Create new hospital"
    title-tag="h5"
    cancel-title="Cancel"
    id="idBranchDetailNewHospitalModal"
    cancel-variant="outline-primary"
    :ok-disabled="hospitalName === ''"
    :ok-title="this.$store.state.hospital ? 'Update' : 'Create'"
    @hidden="clearData"
    @shown="focusFirstInput"
    @show="onShow"
    @ok="onOk"
  >
    <div class="padding">
      <b-row>
        <b-col>
          <label class="required" for="idHospitalName">Hospital Name</label>
          <b-form-input
            size="sm"
            id="idHospitalName"
            trim
            ref="firstInput"
            v-model="hospitalName"
          ></b-form-input>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      hospitalName: "",
    };
  },
  created() {},
  methods: {
    focusFirstInput() {
      this.$refs.firstInput.focus();
    },
    onShow() {
      if (this.$store.state.hospital) {
        this.id = this.$store.state.hospital.id;
        this.hospitalName = this.$store.state.hospital.hospitalName;
      }
    },
    onOk() {
      if (this.$store.state.hospital) {
        this.$emit("updateHospital", {
          id: this.$store.state.hospital.id,
          hospitalName: this.hospitalName,
        });
      } else {
        this.$emit("newHospital", {
          hospitalName: this.hospitalName,
          hospitalLocation: {},
        });
      }
    },
    clearData() {
      this.$store.commit("SET_HOSPITAL_TO_EDIT", null);
      this.hospitalName = "";
    },
  },
};
</script>

<style scoped>
.row {
  margin: 0.8rem 0;
}
</style>